import {Injectable} from '@angular/core';
import {Actions, Effect} from '@ngrx/effects';
import {Observable} from 'rxjs/Observable';
import {Action} from '@ngrx/store';
import {ListManagementService} from '../services/list';
import * as list from '../actions/list';
import * as auth from '../actions/authentication';
import { of } from 'rxjs/observable/of';
import * as routerActions from '../actions/router';
import {ListItem} from '../models/list-item';
import * as log from '../actions/log';
import { ErrorModel } from '../models/error-model';

@Injectable()
export class ListEffects {

  @Effect()
  loadEntireList$: Observable<Action> = this.actions$
    .ofType(list.LOAD_ENTIRE_LIST)
    .map((action: list.LoadEntireListAction) => action.payload)
    .switchMap(pm => {

      const nextLookup$ = this.actions$.ofType(list.LOAD_ENTIRE_LIST).skip(1);
      const errorMessage = 'Error loading list.';
      return this.listService.getEntireList(pm)
        .takeUntil(nextLookup$)
        .map(p => new list.LoadEntireListCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveListItem$: Observable<Action> = this.actions$
    .ofType(list.SAVE_LIST_ITEM)
    .map((action: list.SaveListItemAction) => action.payload)
    .switchMap(li => {

      const nextLookup$ = this.actions$.ofType(list.SAVE_LIST_ITEM).skip(1);
      const errorMessage = 'Error saving list.';
      return this.listService.manageItem(li)
        .takeUntil(nextLookup$)
        .map(p => {
          const rtrn = Object.assign({}, li) as ListItem;
          rtrn.id = p;
          return new list.SaveListItemCompleteAction(rtrn);
        })
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  saveListItemComplete$: Observable<Action> = this.actions$
    .ofType(list.SAVE_LIST_ITEM_COMPLETE)
    .map((action: list.SaveListItemCompleteAction) => action.payload)
    .map(li => {
      return new routerActions.Go({ path: ['admin', 'lists', li.parentLid]});
    });

  @Effect()
  loadListItem$: Observable<Action> = this.actions$
    .ofType(list.LOAD_LIST_ITEM)
    .map((action: list.LoadListItemAction) => action.payload)
    .switchMap(pm => {

      const nextLookup$ = this.actions$.ofType(list.LOAD_LIST_ITEM).skip(1);
      const errorMessage = 'Error loading list item.';
      return this.listService.getItem(pm)
        .takeUntil(nextLookup$)
        .map(p => new list.LoadListItemCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  @Effect()
  loadStateList$: Observable<Action> = this.actions$
    .ofType(list.LOAD_STATE_LIST)
    .switchMap(() => {

      const nextLookup$ = this.actions$.ofType(list.LOAD_STATE_LIST).skip(1);
      const errorMessage = 'Error loading state list.';
      return this.listService.getActiveList('State')
        .takeUntil(nextLookup$)
        .map(p => new list.LoadStateListCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  constructor(private actions$: Actions, private listService: ListManagementService) {}

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/effects/list.ts